import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const TeamSize = ({ classes, user, obfuscateView }) => {
  if (get(user, 'part_of_team')) {
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.team_size"/></strong>
        {!obfuscateView && <p>{get(user, 'team_size')}</p>}
        {obfuscateView && <p className="blurry-text">???</p>}
      </div>
    );
  }
  return <div />;
};

const styles = {
  status : {
    marginBottom : 15,
    width        : 170,
  },
};

export default withStyles(styles)(TeamSize);
